'use client';

import React from 'react';
import { ModalType } from '@printi/ds-offset-react-core';
import { termsOfUseContent } from '@mf/common/pagesContent/termos-de-uso/content';
import { privacyPolicyContent } from '@mf/common/pagesContent/politicas-de-privacidade/content';
import { TopPage } from '@mf/common/components/TopPage';
import { TextBlog } from '@mf/common/components/TextBlog';
import { ArraySections } from '@mf/common/pagesContent/institucional/content';
import {
  Grid,
  ModalContainer,
  ModalContent,
  SectionsContainer,
} from './TermsModal.styles';

interface TermsModalProps {
  type: string;
  isOpen: boolean;
  onClose: () => void;
}

export const TermsModal = ({ type, isOpen, onClose }: TermsModalProps) => {
  function renderConditionalContent(content: ArraySections) {
    if (!content.length) {
      return <></>;
    }

    return content.map((props) => {
      if (props.__component === 'sections.toppage') {
        return (
          <TopPage
            heading={props.heading}
            description={props.description}
            key={props.id}
            contactheading={props.contactheading}
            contactdescription={props.contactdescription}
            tagLabel={props.tagLabel}
          />
        );
      }

      if (props.__component === 'sections.textblog') {
        return (
          <TextBlog
            heading={props.heading}
            items={props.items}
            key={props.id}
            headingSize={props.headingSize}
            onClickButton={props.onClickButton}
            flag={props.flag}
            subheadingItems={props.subheadingItems}
          />
        );
      }
    });
  }

  const content = type === 'terms' ? termsOfUseContent : privacyPolicyContent;

  return (
    <ModalContainer type={ModalType.Slot} isOpen={isOpen} onClose={onClose}>
      <ModalContent>
        {content.map((props) => {
          return (
            <>
              <Grid>
                <SectionsContainer>
                  {renderConditionalContent(props.sections)}
                </SectionsContainer>
              </Grid>
            </>
          );
        })}
      </ModalContent>
    </ModalContainer>
  );
};
